import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home.vue';
import Jobs from '@/components/Jobs.vue';
import JobDetails from '@/components/JobDetails.vue';
import MyDetails from '@/components/MyDetails.vue';
import JobNew from '@/components/JobNew.vue';

Vue.use(Router);

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      component: Home,
      meta: {
        title: 'T2 Services Client Portal',
      },
    },
    {
      path: '/jobs',
      component: Jobs,
      meta: {
        title: 'Jobs - T2 Services Client Portal',
      },
    },
    {
      path: '/new-job',
      component: JobNew,
      meta: {
        title: 'New Job - T2 Services Client Portal',
      },
    },
    {
      path: '/jobs/:id',
      component: JobDetails,
      name: 'job_details',
      props: true,
      meta: {
        title: 'Job Details - T2 Services Client Portal',
      },
    },
    {
      path: '/my-details',
      component: MyDetails,
      meta: {
        title: 'My Details - T2 Services Client Portal',
      },
    },
  ],
});
